import styled from 'styled-components'
import COLORS from '@colors'

export const SectionTitle = styled.h2`
  color: ${COLORS.white};
  font-weight: 800;
  font-size: 18px;
  margin-top: 25px;
  margin-bottom: 25px;
`

export const FilterBar = styled.div`
  bottom: 0;
  color: ${COLORS.white};
  font-size: 14px;
  display: flex;
  flex-direction: column;
  left: 0;
  position: absolute;
  top: 64px;
  transition: 0.1s ease;
  width: ${props => (props.active ? '344px' : '0')};

  ${props =>
    !props.active &&
    `
      div {
        opacity: 0;
        overflow: hidden;
        padding: 0;
        transition: 0.3s ease;
        width: 0;
      }
  `}
`

export const Header = styled.div`
  background-color: ${COLORS.gray28};
  display: flex;
  height: 77px;
  padding: 10px 0;
  transition: 0.3s ease;
  width: 100%;
`

export const HeaderMain = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
`

export const Dock = styled.div`
  top: 6px;
  background-color: ${COLORS.gray45};
  color: white;
  position: relative;
  left: 24px;
  height: 32px;
  width: 25px;
  align-items: center;
  display: flex;
  justify-content: center;
  padding-left: 7px;
  padding-right: 6px;
  cursor: pointer;
  border-radius: 0px 4px 4px 0px;
  user-select: none;
`

export const IconWrapper = styled.div`
  margin-right: 0;

  ${({ searchBar, businessType }) =>
    (searchBar &&
      `
        left: 25px;
        top: 1px;
        position: relative;
      `) ||
    (businessType &&
      `
        margin-right: 6px;
        height: 32px;
      `) ||
    `padding-right: 5px;`}
`

export const ClearFilter = styled.div`
  cursor: pointer;
  display: flex;
  user-select: none;
  display: flex;
  align-items: center;
  height: 32px;
  width: auto;
  transition: none;
`

export const Exit = styled.div`
  cursor: pointer;
  user-select: none;

  &:hover {
    text-decoration: underline;
  }
`

export const Body = styled.div`
  background-color: ${COLORS.gray45};
  color: ${COLORS.white};
  height: calc(100% - 48px);
  overflow-y: scroll;
  padding: 1px 20px 24px 20px;
  width: 344px;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: ${COLORS.gray45};
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.grayC5};
  }
`

export const FilterLabel = styled.p`
  color: ${COLORS.whiteA1};
  margin-bottom: 12px;
  margin-top: 16px;
`

export const RangeContainer = styled.div`
  .rc-slider-rail {
    background-color: ${COLORS.whiteA1};
  }

  .rc-slider-handle,
  .rc-slider-handle:hover {
    background-color: ${COLORS.leather};
    border: 8px solid ${COLORS.leather};
  }

  .rc-slider-track {
    background-color: ${COLORS.leather};
  }
`

export const PriceContainer = styled.div`
  color: ${COLORS.whiteD};
  display: flex;
  width: 100%;
`

export const Option = styled.div`
  color: ${COLORS.whiteA1};
  display: flex;
  margin-bottom: 21px;
  cursor: pointer;
  user-select: none;
  p {
    color: ${COLORS.whiteA1};
  }
  svg {
    margin-right: 10px;
  }
`

export const GeneralContainer = styled.div`
  color: ${COLORS.whiteD};
  display: flex;
  margin-top: ${({ marginTop }) => marginTop || '16'}px;
  width: 100%;
`

export const ValueWrapper = styled.div`
  text-align: ${props => props.align};
  font-size: 14px;
  width: ${props => props.width || '50%'};
  ${props =>
    props.align === 'right' &&
    `
    div, p {
      margin: 0;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      text-align: right;
    }
  `}
`

export const Input = styled.input`
  width: ${props => (props.fullWidth ? '100%' : 'calc(100% - 16px)')};
  border: 0;
  height: 32px;
  border-radius: 4px;
  background-color: ${COLORS.whiteF3};
  outline: 0;
  padding: 0 8px;
  color: ${COLORS.gray45};
`

export const InputWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  border-radius: 0 4px 4px 0;
`

export const FeaturesContainer = styled.div`
  display: flex;
  width: 100%;
`

export const Feature = styled.div`
  width: calc(calc(100% / 3) - 7px);
  margin-right: 11px;

  :last-child {
    margin-right: 0;
  }
`

export const Button = styled.button`
  background-color: ${COLORS.lightGreen};
  border: 0;
  border-radius: 4px;
  color: ${COLORS.gray45};
  font-weight: bold;
  height: 32px;
  width: 264px;
  cursor: pointer;
  outline: 0;
  display: flex;
  justify-content: center;
  padding: 8px;

  :disabled {
    opacity: 0.5;
  }
`

export const Error = styled.p`
  margin-top: 6px;
  color: ${COLORS.rustyRed};
  font-size: 12px;
`

export const Footer = styled.div`
  background-color: ${COLORS.gray28};
  display: flex;
  flex-direction: column;
  height: 83px;
  align-items: center;
  width: 344px;
  padding: 15px 0 8px 0;
  box-shadow: 0 0 2px 0 black;
  z-index: 1;

  p {
    margin-bottom: 8px;
  }
`

export const Text = styled.p`
  font-size: ${({ fontSize }) => (fontSize === 'default' ? 'inherit' : '12px')};
  margin: ${({ noMargin }) => (noMargin ? 'unset' : '8px 0')};
`

export const TextWrapper = styled.p`
  margin: 0 8px;
`

export const Line = styled.div`
  height: 1px;
  background-color: ${COLORS.gray87};
  width: 100%;
  position: relative;
  display: flex;
`
